export default __webpack_public_path__ + "static/media/blueWatsapp.9b95a80f.jpg";